import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  height: 100%;
  .camera-wrapper {
    position: relative;
    background-color: #000;

    .flex {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 0px;
      width: 100%;
      height: 100%;
      padding: 3%;

      h1 {
        font-family: Roboto;
        font-size: 20px;
        font-weight: bold;
        font-style: normal;
        font-stretch: condensed;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        position: relative;
        z-index: 2;
        color: #ffffff;
      }

      h2 {
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: normal;
        text-align: center;
        position: relative;
        z-index: 2;
        color: #ffffff;
      }

      button {
        position: relative;
        margin: 1px 2px;
        z-index: 2;
      }
    }

    .cropped-part {
      position: relative;
      width: 55%;
      height: 60%;
      box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
      z-index: 1;

      &:before {
        display: block;
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        top: -3px;
        left: -3px;
        border-top: 3px solid #fff;
        border-left: 3px solid #fff;
      }
      &:after {
        display: block;
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        top: -3px;
        right: -3px;
        border-top: 3px solid #fff;
        border-right: 3px solid #fff;
      }

      span:before {
        display: block;
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        bottom: -3px;
        left: -3px;
        border-bottom: 3px solid #fff;
        border-left: 3px solid #fff;
      }
      span:after {
        display: block;
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        bottom: -3px;
        right: -3px;
        border-bottom: 3px solid #fff;
        border-right: 3px solid #fff;
      }
    }

    video,
    canvas {
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      max-height: 100%;
      position: relative;
    }
  }

  .hidden {
    display: none;
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    .camera-wrapper,
    #player {
      height: 100%;
    }

    .rotation-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      background: black;

      color: white;

      h1 {
        font-family: Roboto;
        font-size: 20px;
        font-weight: bold;
        font-style: normal;
        font-stretch: condensed;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        position: relative;
        z-index: 2;
        color: #ffffff;
      }

      h2 {
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: normal;
        text-align: center;
        position: relative;
        z-index: 2;
        color: #ffffff;
        max-width: 50vw;
      }
    }

    .camera-wrapper {
      .cropped-part {
        width: 91.7222222222222%;
        /* 330.2px / 360px */
        height: 35.140625%;
        margin-top: 30vh;
        /* 224.9px / 640px */
      }

      canvas {
        top: 50%;
        transform: translateY(-50%);
      }

      /* .button-wrapper,
      .camera-capture-btn {
        margin-bottom: 3.828125%;
      }

      .button-section {
      }

      .button-wrapper {
        display: flex;
        justify-content: center;
        .again-btn {
          background-color: rgba(0, 0, 0, 0);
        }
      } */

      .info-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 50px;
        width: 100%;
        height: 100%;
        padding: 3%;

        h1 {
          font-family: Roboto;
          font-size: 20px;
          font-weight: bold;
          font-style: normal;
          font-stretch: condensed;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          position: relative;
          z-index: 2;
          color: #ffffff;
        }

        h2 {
          font-family: Roboto;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: center;
          position: relative;
          z-index: 2;
          color: #ffffff;
          max-width: 50vw;
        }
      }

      .camera-buttons {
        position: fixed;
        z-index: 2;

        bottom: 0;
        margin-bottom: env(safe-area-inset-bottom);

        padding-bottom: 5px;
        padding-top: 5px;

        background: black;

        display: flex;
        justify-content: center;
        align-items: center;

        width: 100%;

        .again-btn {
          background-color: rgba(0, 0, 0, 0);
        }

        .capture-btn {
          background-color: ${({ theme }) => theme.colors.primary.color};
          border: none;
          border-radius: 50%;

          height: 56px;
          width: 56px;

          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            background-color: ${({ theme }) =>
              theme.colors.primary.shades['70']};
          }

          .camera-capture-svg {
            position: relative;
            z-index: 3;

            svg > g > g {
              fill: white;
            }
          }
        }
      }
    }
  }
`;
